<template>
  <div class="card card-custom">
    <!--begin::Header-->
    <div class="card-header py-5">
      <div class="card-title align-items-start flex-column">
        <h3 class="card-label font-weight-bolder text-dark">Timeline</h3>

      </div>

    </div>
    <!--end::Header-->
    <!--begin::Form-->
    <div v-if="loading">
      <v-skeleton-loader
          v-bind="attrs"
          type="list-item-three-line"
      ></v-skeleton-loader>
      <v-skeleton-loader
          v-bind="attrs"
          type="list-item-three-line"
      ></v-skeleton-loader>
      <v-skeleton-loader
          v-bind="attrs"
          type="list-item-three-line"
      ></v-skeleton-loader>
    </div>
    <div v-else>
      <form class="form">
        <div class="card-body" v-if="time_lines && time_lines.length>0">

          <v-row v-for="(time, index) of time_lines" :key="index">
            <v-col cols="12">
              <h6>{{ `${time.program} - ${time.grade}` }}</h6>
              <table class="table">
                <tr v-for="(book, i) of time.book_name" :key="i">
                  <td>{{ book }}</td>
                </tr>
              </table>
            </v-col>
          </v-row>
        </div>
        <div  class="card-body text-center" v-else>
          <h4>No data found</h4>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import IssueService from "@/core/services/library/issue/IssueService";

const issueService = new IssueService();

export default {
  name: "TimeLine",
  props: ['user'],
  data() {
    return {
      time_lines: [],
      loading:false
    }
  },
  computed: {
    current_user() {
      return this.$store.getters.currentUser;
    }
  }, mounted() {
    this.getTimeLine()
  },
  methods: {
    getTimeLine() {
      issueService.issueTimeline(this.user.id).then(response => {
        this.time_lines = response.data
      })
    }
  }
}
</script>

<style scoped>

</style>